const RootBlockType = {
  Default: "default",
  Paragraph: "paragraph",
  Heading1: "heading-one",
  Heading2: "heading-two",
  Heading3: "heading-three",
  Heading4: "heading-four",
  Heading5: "heading-five",
  Heading6: "heading-six",
  BlockQuote: "blockquote",
  UnorderedList: "unordered-list",
  OrderedList: "ordered-list"
};
const BlockType = {
  ...RootBlockType,
  ListItem: "list-item",
  ListItemChild: "list-item-child"
};
const InlineType = {
  Code: "code",
  SuperScript: "superscript",
  SubScript: "subscript",
  Link: "link"
};
const BlockTextAlignment = {
  Left: "left",
  Center: "center",
  Right: "right",
  Justify: "justify"
};
export {
  BlockTextAlignment,
  BlockType,
  InlineType,
  RootBlockType
};
//# sourceMappingURL=types.js.map